import { ValidationMessages } from "@/types/functions";

const validationFR: ValidationMessages = {
    'min_length': '{field} doit avoir sélectionné au moins 0:{min} éléments',
    'max_length': '{field} doit avoir sélectionné au maximum 0:{max} éléments',
    'multiple': 'Le {field} doit être un multiple de 0:{multiple}.'
}

export default validationFR
